import { ArraySourceComposer } from '@/auth/api/connector'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { GlobalLoadingComponent } from '@/components/GlobalLoadingComponent/GlobalLoadingComponent'
import { ordine, user } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { useQuery } from '@tanstack/react-query'
import { Button, Lookup } from 'devextreme-react'
import { PopupRef } from 'devextreme-react/popup'
import notify from 'devextreme/ui/notify'
import { type RefObject, useState } from 'react'

interface OrderAssignSelectorProps {
  order: ordine | null | undefined
  popupAssignRef: RefObject<PopupRef>
  onAssign: (order: ordine, assignee: user) => void
}

// L'elenco degli assegnatari (ruoli inclusi) è calcolato dal backend
const getOrderAssignees = async () => {
  const response = await useQsAdminApiManager.getState().client.get('/api/ordine/assignees')
  return response.data as user[]
}

export const getOrderSelfAssignableUserByEmail = async (email: string | null | undefined) => {
  if (!email) return undefined

  const assignees = await getOrderAssignees()
  return assignees.find((assignee) => assignee.email?.toLowerCase() === email.toLowerCase())
}

const OrderAssignSelector = ({ order, popupAssignRef, onAssign }: OrderAssignSelectorProps) => {
  const [assignee, setAssignee] = useState<user | null>(null)
  const { data: employees, isLoading } = useQuery({
    queryKey: ['order-assignment-employees'],
    queryFn: getOrderAssignees,
  })

  if (isLoading) return <GlobalLoadingComponent />
  if (!order) return <div>Ordine non trovato</div>

  return (
    <div className="responsive-paddings">
      <form
        className="dx-form"
        onSubmit={(event) => {
          event.preventDefault()
          if (!assignee) return

          try {
            onAssign(order, assignee)
          } catch (error) {
            notify(`Errore assegnazione ordine '${order.ded_Dis}'. Dettagli: ${error}`, 'error', 3000)
          } finally {
            popupAssignRef.current?.instance().hide()
          }
        }}
      >
        <div className="dx-field dx-col">
          <Lookup
            dataSource={ArraySourceComposer('id', employees)}
            displayExpr="fullname"
            placeholder="Assegna a..."
            showClearButton={true}
            searchEnabled={true}
            width="100%"
            onValueChanged={(event) => setAssignee(event.value)}
          />
        </div>
        <Button type="success" useSubmitBehavior={true} disabled={!assignee} text="Assegna" icon="check" />
      </form>
    </div>
  )
}

export default OrderAssignSelector
